import { LandTitleRegisterDto } from '@cradua/data';
import { createAction, props } from "@ngrx/store";

/**
 * Load Generic Collection Actions
 */

export const loadAcquisitionDocument = createAction(
  "[Acquisition-Document] Load Acquisition Document",
  props<{ id: any; }>(),
  );

export const loadAcquisitionDocumentSuccess = createAction(
  "[Acquisition-Document] Load Acquisition Document Success",
  props<{ document: LandTitleRegisterDto[] }>(),
);

export const loadAcquisitionDocumentFailure = createAction(
  "[Acquisition-Document] Load Acquisition Document Failure",
  props<{ error: any }>(),
);

/**
 * Add Acquisition to Collection Actions
 */
export const addAcquisitionDocument = createAction(
  "[Acquisition-Document] Add Documents Acquisition",
  props<{
    newDocument: LandTitleRegisterDto[];
  }>(),
);

export const addAcquisitionDocumentSuccess = createAction(
  "[Acquisition-Document] Add Acquisition Documents Success",
  props<{ newDocument: LandTitleRegisterDto[] }>(),
);

export const addAcquisitionDocumentFailure = createAction(
  "[Acquisition-Document] Add Acquisition Documents Failure",
  props<{ error: any }>(),
);


/**
 * Load Clear State Actions
 */

export const loadClearAcquisitionDocument = createAction(
  "[Acquisition-Document] Load Clear Acquisition Document"
  );

export const loadClearAcquisitionDocumentSuccess = createAction(
  "[Acquisition-Document] Load Clear Acquisition Document Success",
  props<{ document: LandTitleRegisterDto[] }>(),
);

export const documentUploadRequest = createAction(
  "[Generic Documents] Upload Documents",
  props<{ file: File; document: any }>(),
);

export const documentUploadCancel = createAction(
  "[Generic Documents Upload Cancel] Cancel",
);

export const documentUploadReset = createAction(
  "[Generic Documents Upload Reset] Reset",
);

export const documentUploadStarted = createAction(
  "[Generic Documents Upload API] Started",
);

export const documentUploadProgress = createAction(
  "[Generic Documents Upload API] Progress",
  props<{ progress: number }>(),
);

export const documentUploadFailure = createAction(
  "[Generic Documents Upload API] Failure",
  props<{ error: any }>(),
);

export const documentUploadSuccess = createAction(
  "[Generic Documents Upload API]  Success",
  props<{ newDocument: LandTitleRegisterDto }>(),
);


// export const addAcquisitionFailure = createAction(
//   "[Acquisition] Add Acquisition Failure",
//   props<{ error: any }>(),
// );

export const documentUploadCompleted = createAction(
  "[Generic Documents Upload API]  Completed",
);
